import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

const DropDownMenu = ({
  options,
  value,
  label,
  onChange,
  sx = { width: 250 }, //Default to 250px width
  disabledLabel = label, //Default to label if not provided
  variant = "outlined",
}) => (
  <FormControl variant={variant} sx={sx}>
    <InputLabel id="dropdown-label">{label}</InputLabel>
    <Select
      labelId="dropdown-label"
      id="dropdown"
      value={value}
      label={label}
      onChange={onChange}
    >
      {disabledLabel && (
        <MenuItem value="" disabled>
          {disabledLabel}
        </MenuItem>
      )}
      {options.map(({ key, text, disabled }) => (
        <MenuItem key={key} value={key} disabled={disabled}>
          {text}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

DropDownMenu.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
  disabledLabel: PropTypes.string,
  variant: PropTypes.string,
};

export default DropDownMenu;
